import React from "react";
import { Experiencias } from "./styled";

export const Experiencia1 = () => {
  return (
    <>
      <Experiencias>EXPERIENCIA</Experiencias>
    </>
  );
};
